import { normalizeUserFacingErrorMessage } from './errorMessages';
import { getClientVersionHeaders, isCheckAuthUrl } from './clientVersion';

export const safeFetch = async (url, options = {}, timeout = 8000) => {
    const controller = new AbortController();
    const timeoutId = setTimeout(() => controller.abort(), timeout);

    // Автоматически добавляем токен авторизации
    const token = localStorage.getItem('token');
    
    // Получаем заголовки из options или создаём пустой объект
    const optionsHeaders = options.headers || {};
    
    // Формируем итоговые заголовки: базовые + токен + переданные
    const isFormDataBody = typeof FormData !== 'undefined' && options?.body instanceof FormData;
    const headers = {
      ...(!isFormDataBody ? { 'Content-Type': 'application/json' } : {}),
      ...(token && { 'Authorization': `Bearer ${token}` }),
      ...(isCheckAuthUrl(url) ? getClientVersionHeaders() : {}),
      ...optionsHeaders
    };

    try {
      const response = await fetch(url, {
        ...options,
        headers,
        signal: controller.signal
      });
      clearTimeout(timeoutId);

      let data;
      try {
        data = await response.json();
      } catch (parseError) {
        console.warn('Ошибка парсинга JSON:', parseError);
        if (!response.ok) {
          if (response.status === 404) throw new Error('Маршрут не найден на сервере (404)');
          if (response.status === 403) throw new Error('Доступ запрещён (403)');
          if (response.status === 502) throw new Error('Сервер недоступен (502 Bad Gateway)');
          if (response.status === 504) throw new Error('Время ожидания ответа сервера истекло (504 Gateway Timeout)');
          if (response.status >= 500) throw new Error(`Внутренняя ошибка сервера (${response.status})`);
        }
        throw new Error('Ошибка обработки ответа сервера');
      }

      if (!response.ok) {
        // Специфическая обработка HTTP ошибок
        const detailStr = String(data?.detail || data?.message || '');
        const authCode = response.headers.get('x-auth-code') || '';
        const isUserBlocked = authCode === 'USER_BLOCKED' || authCode === 'USER_DELETED'
          || /заблокирован|удалён|удален/i.test(detailStr);

        if (response.status === 401) {
          // Удаляем токен и уведомляем приложение
          localStorage.removeItem('token');
          localStorage.removeItem('user_type');
          sessionStorage.setItem('auth_notice', isUserBlocked ? 'user-blocked' : 'session-ended');
          // Dispatch событие для уведомления других компонентов
          window.dispatchEvent(new CustomEvent('auth-error', {
            detail: {
              type: isUserBlocked ? 'user_blocked' : 'unauthorized',
              message: detailStr || 'Сессия завершена'
            }
          }));
          throw new Error(isUserBlocked ? (detailStr || 'Учетная запись заблокирована') : 'Сессия истекла. Требуется авторизация');
        }
        if (response.status === 403) {
          if (isUserBlocked) {
            localStorage.removeItem('token');
            localStorage.removeItem('user_type');
            sessionStorage.setItem('auth_notice', 'user-blocked');
            window.dispatchEvent(new CustomEvent('auth-error', {
              detail: {
                type: 'user_blocked',
                message: detailStr || 'Пользователь заблокирован'
              }
            }));
            throw new Error(detailStr || 'Учетная запись заблокирована');
          }
          throw new Error(detailStr || 'Доступ запрещён');
        }
        if (response.status === 404) throw new Error(data?.detail || 'Ресурс не найден');
        if (response.status >= 500) {
          const detail = data?.detail || data?.message;
          throw new Error(detail ? `Ошибка сервера: ${detail}` : 'Ошибка сервера');
        }

        const errorDetail = data?.detail || data?.message || `Ошибка ${response.status}`;
        throw new Error(errorDetail);
      }

      if (typeof window !== 'undefined') {
        window.dispatchEvent(new CustomEvent('network-server-reachable'));
      }

      return data;
    } catch (error) {
      clearTimeout(timeoutId);
      console.error('Ошибка safeFetch:', error);

      throw new Error(
        normalizeUserFacingErrorMessage(
          error?.name === 'AbortError'
            ? 'timeout'
            : (error?.message || error)
        )
      );
    }
  };
